<template>
    <div>
        <ul class="nav nav-tabs">
        <li
            v-for="(tab, index) in tabs"
            :key="index"
            class="nav-item"
            :class="{ 'active': tab.isActive == selectedTab }"
        >
            <a
            href="#"
            class="nav-link"
            :class="{ active: tab.isActive }"
            @click.prevent="selectTab(index)"
            >
            {{ tab.title }} {{ index }} {{ selectedTabIndex }}
            </a>
        </li>
        </ul>
        <div class="tab-content">
            <slot></slot>   
        </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, provide, reactive, watch } from 'vue';
  
  export default defineComponent({
    name: 'Tabs',
    props: {
        selectedTabIndex: {
            type: Number,
            default: 0,
        },
    },
    setup(props, { emit, expose }) {
      const tabs = reactive({
        s : 0,
        items: [],
        addTab(tab) {
          this.items.push(tab);
        },
      });
  
      var selectTab = (selectedIndex) => {
        // console.log("selectedIndex", selectedIndex);
        // console.log("tabs.items", tabs.items);
        tabs.items.forEach((tab, index) => {
            // console.log("index ====", index);
            // console.log("tab ===== ", tab.isActive);
            tab.isActive = index == selectedIndex;

            console.log("tab ===== ", tab.isActive);
            console.log("tab == title === ", tab.title);
        });

        // emit('tab-selected', selectedIndex);
      };
      const getSelectedTab = () => {
        return tabs.items.find(tab => tab.isActive);
      };

      provide('tabs', tabs);
  
      expose({
        getSelectedTab,
      });
      
      watch(() => props.selectedTabIndex, (newIndex) => {
            selectTab(newIndex);
        }, { immediate: true });

      return {
        tabs: tabs.items,
        selectTab,
      };
    },
  });
  </script>
  
  <style>
  .nav-tabs {
    border-bottom: 1px solid #ddd;
  }
  
  .nav-item {
    margin-bottom: -1px;
  }
  
  .nav-link {
    padding: 10px 15px;
    cursor: pointer;
  }
  
  .nav-link.active {
    background-color: #fff;
    border: 1px solid #ddd;
    border-bottom-color: transparent;
  }
  
  .tab-content {
    padding: 15px;
    border: 1px solid #ddd;
    border-top: none;
  }
  </style>
  